import { call, put, takeEvery } from "redux-saga/effects";
import { xepTkbApi } from "../../../api/tkb/xepTkbApi";
import { ISuKienSelectRequest } from "../../../model/request/tkb/ISuKienSelectRequest";
import { ISuKienUpdateRequest } from "../../../model/request/tkb/ISuKienUpdateRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { ePhanPhongHocActionIds } from "../../action-types/tkb/IPhanPhongActions";
import { IXepTKBActionTypes } from "../../action-types/tkb/IXepTKBActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.tkb.phanPhongHoc;
export function* phanPhongHocSaga(): any {
  yield takeEvery(ePhanPhongHocActionIds.LOAD_ALL_START, loadKeHoachMonWorker);
  yield takeEvery(ePhanPhongHocActionIds.UPDATE_GV_PH_SUKIEN_START, updateGVPHWorker);
}

function* loadKeHoachMonWorker(action: IXepTKBActionTypes): any {
  const res: IBaseRespone = yield call(xepTkbApi.SelectPhanPhong, action.payload as ISuKienSelectRequest);
  if (res.is_success) {
    yield put(mainAction.LOAD_ALL_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ALL_ERRR(res.message ?? "Có lỗi"));
  }
}



function* updateGVPHWorker(action: IXepTKBActionTypes): any {
  const res: IBaseRespone = yield call(xepTkbApi.UpdatePhongHoc, action.payload as ISuKienUpdateRequest);
  if (res.is_success) {
    yield put(mainAction.UPDATE_GV_PH_SUKIEN_SUCCESS(res.data));
  } else {
    yield put(mainAction.UPDATE_GV_PH_SUKIEN_ERRR(res.message ?? "Có lỗi"));
  }
}
